import { render, staticRenderFns } from "./newPage.vue?vue&type=template&id=455c6f05&scoped=true"
import script from "./newPage.vue?vue&type=script&lang=js"
export * from "./newPage.vue?vue&type=script&lang=js"
import style0 from "./newPage.vue?vue&type=style&index=0&id=455c6f05&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455c6f05",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('455c6f05')) {
      api.createRecord('455c6f05', component.options)
    } else {
      api.reload('455c6f05', component.options)
    }
    module.hot.accept("./newPage.vue?vue&type=template&id=455c6f05&scoped=true", function () {
      api.rerender('455c6f05', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/newPage.vue"
export default component.exports